import React, { useEffect, useState } from 'react';
import { Switch } from 'react-router-dom';
import PrivateRoute from '../helper/PrivateRoute';
import PublicRoute from '../helper/PublicRoute';
import DefaultRoute from '../helper/DefaultRoute';
import { DESKTOP_SIDE_BAR_MENU } from '../config/general.config';
import fernet from 'fernet';
import { btoa } from 'js-base64';
import utf8 from 'utf8';

import Upcoming from '../Desktop/Today/home';

import Casino from '../Desktop/Casino';
import CasinoGame from '../Desktop/Casino/SingleGame';
import LiveCasino from '../Desktop/LiveCasino';
import LiveCasinoGame from '../Desktop/LiveCasino/SingleGame';

import MyAccount from '../Components/MyAccount';
import MyBets from '../Components/MyBets';
import Betslip from '../Components/Betslip';
import Transactions from '../Components/Transactions';

import Inplay from '../Desktop/Inplay/home';
import Results from '../Desktop/Results';
import Today from '../Desktop/Today/home';
import LastMinute from '../Components/LastMinute';
import Favorites from '../Desktop/Favorites';

import ExtraOddsModal from '../Desktop/Inplay/ExtraOddsModal';
import ExtraOddsModalPrematch from '../Desktop/Shared/ExtraOddsModal';

import Auth from '../store/Auth';
import '../assets/style/Desktop/index.css';
import Promotion from '../Desktop/Promotion';
import CustomerService from '../Desktop/CustomerService/index.js';
import Loyalty from '../Desktop/Loyalty';
import Winners from '../Desktop/Winners';


import ContactUs from '../Desktop/Common/Support/ContactUs';
import PrivacyPolicy from '../Desktop/Common/Support/PrivacyPolicy';
import CookiePolicy from '../Desktop/Common/Support/CookiePolicy';
import Faq from '../Desktop/Common/Support/Faq';
import TermsAndConditions from '../Desktop/Common/Support/TermsAndConditions';
import BonusRules from '../Desktop/Common/Support/BonusRules';
import AboutJackpotCT from '../Desktop/Common/About/AboutJackpotCT';
import Introduction from '../Desktop/Common/ResponsibleGaming/Introduction';
import Limits from '../Desktop/Common/ResponsibleGaming/Limits';
import { toastr } from 'react-redux-toastr';
import PromotionItem from '../Desktop/Promotion/PromotionItem';
import LiveCategory from '../Desktop/LiveCasino/Category';
import Providers from '../Desktop/Casino/Providers';
import LiveCasinoNewGames from '../Desktop/LiveCasino/NewGames';
import GameList from '../Desktop/Casino/GameList';
import Profile from '../Desktop/MyAccount/Profile';
import { Translate } from '../localization';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setLanguage } from '../store/actions/general.actions.js';

function DesktopRoutes(props) {
    const history = useHistory()
    const options = ['en-US', 'zh-CN', 'zh-TW', 'th', 'ko']

    const [path, setPath] = useState(Translate.getLanguage())
    let langCode
    const dispatch = useDispatch()
    const location = useLocation()
    //Get current language code 
    useEffect(() => {
        langCode = Translate.getLanguage()
        setPath(langCode)
    }, [options])
    useEffect(() => {
        const pathArray = props.history.location.pathname.split('/');
        //Checking if the url contain any agent code
        if (pathArray.includes('affiliate-invite') && (props.history.location.search.split('=')[1])) {
            let agentCode = new URLSearchParams(props.history.location.search).get('affiliate_code');
            // Saving agent code in localStorage and then use at the time of signup
            if (!isNaN(agentCode)) {
                localStorage.setItem('agentCode', agentCode);
                localStorage.setItem('firstAgentCodeHit', true);
            } else {
                toastr.error('', 'Invalid agent referral!');
            }
        }
        //Checking if the url not valid then redirect to the home page
        if (!options.includes(location.pathname.split('/')[1]) || location.pathname.split('/')[2] !== 'd' || location.pathname.split('/')[3] === '' || !location.pathname.split('/')[3]) {
            history.push(`/${path}/d/casino`)
        } else {
            dispatch(setLanguage(location.pathname.split('/')[1]));
            localStorage.setItem('language', location.pathname.split('/')[1]);
            setPath(location.pathname.split('/')[1])
        }
    });
    if (['support', 'about', 'responsible-gaming'].includes(location.pathname.split('/')[2]) && (!location.pathname.split('/')[3] || location.pathname.split('/')[3] == '')) {
        let index = ['support', 'about', 'responsible-gaming'].indexOf(location.pathname.split('/')[2]);
        history.push(DESKTOP_SIDE_BAR_MENU[index].path);
    }
    return (
        <>
            <Auth>
                <Switch>
                    <PublicRoute exact path={`/${path}/d/sports`} component={Upcoming} />
                    <PublicRoute exact path={`/${path}/d/live-betting`} component={Inplay} />
                    <PublicRoute exact path={`/${path}/d/casino`} component={Casino} headerClass="header_transparent" title="casino" />
                    {/* <PublicRoute exact path={`/d/casino`} component={Casino} headerClass="header_transparent" title="casino" /> */}
                    <PublicRoute exact path={`/${path}/d/casino/providers/:provider_id`} component={GameList} headerClass="header_transparent" title="provider" />
                    <PublicRoute exact path={`/${path}/d/affiliate-invite`} component={Casino} headerClainviss="header_transparent" title="casino" />
                    <PublicRoute exact path={`/${path}/d/casino/game/:gameTitle`} component={CasinoGame} />
                    <PublicRoute exact path={`/${path}/d/casino/categories/:category`} component={GameList} />
                    <PublicRoute exact path={`/${path}/d/live-casino/categories/:search`} component={LiveCategory} />
                    {/* <PublicRoute exact path="/d/casino/special-category/:slug" component={GameList} /> */}
                    <PublicRoute exact path={`/${path}/d/casino/special-category/:slug`} component={GameList} />
                    <PublicRoute exact path={`/${path}/d/live-casino/new`} component={LiveCasinoNewGames} />
                    <PublicRoute exact path={`/${path}/d/casino/providers`} component={Providers} />
                    <PublicRoute exact path={`/${path}/d/live-casino`} component={LiveCasino} headerClass="header_transparent" title="liveCasino" />
                    <PrivateRoute exact path={`/${path}/d/live-casino/game/:gameTitle`} component={LiveCasinoGame} />
                    {/* <PrivateRoute exact path="/d/virtual-sports" component={VirtualSports} headerClass="header_transparent" title="VirtualSports" /> */}

                    <PrivateRoute exact path={`/${path}/d/my-account`} component={MyAccount} headerClass="header_white" title="myAccount" />
                    <PrivateRoute exact path={`/${path}/d/my-bets`} component={MyBets} headerClass="header_white" title="myBets" />
                    <PublicRoute exact path={`/${path}/d/betslip`} component={Betslip} headerClass="header_white" title="betslip" />
                    <PrivateRoute exact path={`/${path}/d/my-account/transactions`} component={Transactions} headerClass="header_white" title="transaction" />
                    <PrivateRoute exact path={`/${path}/d/my-account/profile`} component={Profile} headerClass="header_white" title="transaction" />
                    {/* <PublicRoute exact path="/d/sports" component={Prematch} headerClass="header_white" title="sports" /> */}
                    <PublicRoute exact path={`/${path}/d/results`} component={Results} headerClass="header_white" title="results" />
                    <PublicRoute exact path={`/${path}/d/today`} component={Today} headerClass="header_white" title="today" />
                    <PublicRoute exact path={`/${path}/d/last-minute`} component={LastMinute} headerClass="header_white" title="lastMinute" />
                    <PrivateRoute exact path={`/${path}/d/favorites`} component={Favorites} headerClass="header_white" title="favorites" />
                    <PublicRoute exact path={`/${path}/d/promotion`} component={Promotion} headerClass="header_white" title="promotion" />
                    {/* <PublicRoute exact path="/d/privacy-policy" component={PrivacyPolicy} headerClass="header_white" title="privacy-policy" />
                    <PublicRoute exact path="/d/terms-and-conditions" component={TermsAndConditions} headerClass="header_white" title="terms-and-conditions" /> */}
                    {/* <PublicRoute exact path="/d/promotion/first-deposit-bonus" component={FirstDepositBonus} headerClass="header_white" title="first-deposit-bonus" />
                    <PublicRoute exact path="/d/promotion/champions-league-rules" component={ChampionsLeagueRules} headerClass="header_white" title="Champions-league-rules" />
                    <PublicRoute exact path="/d/promotion/take-it-all" component={TakeItAll} headerClass="header_white" title="take-it-all" /> */}
                    <PublicRoute exact path={`/${path}/d/promotion/:slug`} component={PromotionItem} headerClass="header_white" title="promotion_item" />
                    <PublicRoute exact path={`/${path}/d/customerServices`} component={CustomerService} headerClass="header_white" title="customerService" />
                    {/* <PublicRoute exact path="/d/live-bettingextra-market/:sportId/:fixtureId/:liveStreamAvailable" component={Home} isMobileOnly={ props.isMobileOnly } isExtraMarket={true} headerClass="header_white" extraMarketChild={ExtraOddsModal} title="ExtraOddsModal" />
                    <PublicRoute exact path="/d/extra-market/:sportId/:fixtureId" component={Home} isMobileOnly={ props.isMobileOnly } isExtraMarket={true} headerClass="header_white" extraMarketChild={ExtraOddsModalPrematch} title="ExtraOddsModal" /> */}
                    <PublicRoute exact path={`/${path}/d/live-bettingextra-market/:sportId/:fixtureId/:liveStreamAvailable`} component={Inplay} isMobileOnly={props.isMobileOnly} isExtraMarket={true} headerClass="header_white" extraMarketChild={ExtraOddsModal} title="ExtraOddsModal" />
                    <PublicRoute exact path={`/${path}/d/extra-market/:sportId/:fixtureId`} component={Today} isMobileOnly={props.isMobileOnly} isExtraMarket={true} headerClass="header_white" extraMarketChild={ExtraOddsModalPrematch} title="ExtraOddsModal" />
                    {/* <PrivateRoute exact path="/d/ggslot" component={Ggslot} headerClass="header_white" title="casino" /> */}
                    <PublicRoute exact path={`/${path}/d/loyalty`} component={Loyalty} />
                    <PublicRoute exact path={`/${path}/d/hall-of-fame`} component={Winners} />

                    {/* # Support/About/Responsible-Gaming pages  */}
                    <PublicRoute exact path={`/${path}/d/support/contact-us`} component={ContactUs} headerClass="header_white" title="terms-and-conditions" />
                    <PublicRoute exact path={`/${path}/d/support/faq`} component={Faq} headerClass="header_white" title="terms-and-conditions" />
                    <PublicRoute exact path={`/${path}/d/support/terms-and-conditions`} component={TermsAndConditions} headerClass="header_white" title="terms-and-conditions" />
                    <PublicRoute exact path={`/${path}/d/support/privacy-policy`} component={PrivacyPolicy} headerClass="header_white" title="terms-and-conditions" />
                    <PublicRoute exact path={`/${path}/d/support/cookie-policy`} component={CookiePolicy} headerClass="header_white" title="terms-and-conditions" />
                    <PublicRoute exact path={`/${path}/d/support/bonus-rules`} component={BonusRules} headerClass="header_white" title="terms-and-conditions" />
                    <PublicRoute exact path={`/${path}/d/about/about-jackpotCT`} component={AboutJackpotCT} headerClass="header_white" title="terms-and-conditions" />
                    {/* <PublicRoute exact path="/d/ad-sponsor" component={AdSponsor} headerClass="header_white" title="terms-and-conditions" /> */}
                    <PublicRoute exact path={`/${path}/d/responsible-gaming/introduction`} component={Introduction} headerClass="header_white" title="terms-and-conditions" />
                    <PublicRoute exact path={`/${path}/d/responsible-gaming/limits`} component={Limits} headerClass="header_white" title="terms-and-conditions" />
                    <DefaultRoute />
                </Switch>
            </Auth>
        </>
    );
}

export default DesktopRoutes;
